import RequiredIndicator from "@base/ui/RequiredIndicator";
import { Select, useSelectContext } from "@ark-ui/react";
import type { ComponentProps } from "react";

type Props = Omit<ComponentProps<typeof Select.Label>, "className">;

const Label = ({ children, ...rest }: Props) => {
  const { getHiddenSelectProps } = useSelectContext();
  const { required } = getHiddenSelectProps();

  return (
    <Select.Label {...rest} className="text-label2">
      {children} {required && <RequiredIndicator />}
    </Select.Label>
  );
};

export default Label;
